<form [formGroup]="formGroup" id="form-base-data">
  <formly-form [fields]="fields" [form]="formGroup" [model]="model">
  </formly-form>
</form>
